import { render } from "./CardRow2.vue?vue&type=template&id=71ad38dc&scoped=true"
import script from "./CardRow2.vue?vue&type=script&lang=js"
export * from "./CardRow2.vue?vue&type=script&lang=js"

import "./CardRow2.vue?vue&type=style&index=0&id=71ad38dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ad38dc"]])

export default __exports__